// extracted by css-extract-rspack-plugin
export default {"datePickerContainer":"BankDetails_datePickerContainer__JqGyB"};